module.exports = __webpack_public_path__ + "media/icons/info-cc63ce4e.svg";